import { Controller } from '@hotwired/stimulus'

// Handles the live countdown timer in the impersonation banner
export default class extends Controller {
  static targets = ['countdown']
  static values = { expiresAt: Number }

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  tick() {
    const now = Math.floor(Date.now() / 1000)
    const remaining = this.expiresAtValue - now

    if (remaining <= 0) {
      this.countdownTarget.textContent = 'Expired'
      clearInterval(this.timer)
      // Reload page to trigger server-side timeout handling
      window.location.reload()
      return
    }

    const minutes = Math.floor(remaining / 60)
    const seconds = remaining % 60

    if (minutes > 0) {
      this.countdownTarget.textContent = `${minutes}m ${seconds.toString().padStart(2, '0')}s`
    } else {
      this.countdownTarget.textContent = `${seconds}s`
    }
  }
}
